import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function searchClients(term, limitCount = 5) {
  const q = query(
    collection(db, 'artifacts', appId, 'public', 'data', 'clients'),
    where('searchKeywords', 'array-contains', term.toLowerCase()),
    limit(limitCount)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, title: d.data().qualification?.physical?.name || 'Cliente' }));
}

// Fusão Processos/Caderno (MC33): processes vazia - redireciona para
// autos_workspaces (searchKeywords do MC07). Quase duplicata de
// ClientRepository.searchProcessesByTerm (MC32) - dívida técnica
// registrada no Pré-Voo, não consolidada aqui, fora de escopo.
export async function searchProcesses(term, limitCount = 5) {
  const q = query(
    collection(db, 'artifacts', appId, 'public', 'data', 'autos_workspaces'),
    where('searchKeywords', 'array-contains', term.toLowerCase()),
    limit(limitCount)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, title: d.data().numeroCNJ }));
}
